/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getQuotes.defs.js'
export { main as default } from './getQuotes.defs.js'
